import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

import useAuth from '@hooks/useAuth';
import { useKeycloak } from '@hooks/useKeycloak';

interface ProtectedRouteProps {
  children: ReactNode;
  isPrivate?: boolean;
  onlyAuth?: boolean;
}

const ProtectedRoute = ({ children, isPrivate = false, onlyAuth = false }: ProtectedRouteProps) => {
  const { isLoggedIn } = useAuth();
  const { initialized, keycloak } = useKeycloak();
  const location = useLocation();

  // If Keycloak isn't initialized, we rely on KeycloakProvider to show loading or handled here
  // But KeycloakProvider only shows loading if keycloak obj is missing.
  // If initialized turned true, we proceed.

  // If route is for auth pages only (login, signup) and user is logged in, redirect away
  if (onlyAuth && isLoggedIn) {
    return <Navigate to='/requisitions' replace />;
  }

  // If route is private and user is not logged in, redirect to login
  // Only redirect if Keycloak is initialized and we're certain the user is not logged in
  if (isPrivate && !isLoggedIn && initialized && keycloak) {
    return <Navigate to='/login' state={{ pathname: location.pathname }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
